import { render } from "./AboutApp.vue?vue&type=template&id=ac12a8c6"
import script from "./AboutApp.vue?vue&type=script&lang=js"
export * from "./AboutApp.vue?vue&type=script&lang=js"

import "./AboutApp.vue?vue&type=style&index=0&id=ac12a8c6&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__